import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { updateBasicInformation } from "../../../reducers/talentMypage";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { LoadingSpinner } from './../../../components/Icons'
import CustomIconButton from "../../../components/CustomIconButton";
import CheckboxButton from "../../../components/CheckboxButton";
import TextInput from "../../../components/TextInput";
import i18n from 'i18next';
import CustomButton from "../../../components/CustomButton";

const DesiredConditions = ({ onClose }: any) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {talent, isLoading} = useSelector((state: any) => state.talentMypage)
    let expectedCondition = talent?.last_company?.expected_condition_new
    let expectedConditionList = expectedCondition ? expectedCondition?.split(' | ') : []
    let expectedConditionListFull = talent?.last_company?.expected_condition_full?.split(' | ') || [];
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
    const [unselectedOptions, setUnselectedOptions] = useState<string[]>([]);
    const [dataOtherExpectedCondition, setDataOtherExpectedCondition] = useState<string[]>([]);
    const [isDisplay, setDisplay] = useState(false)
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
      if(talent) {
        expectedCondition = talent?.last_company?.expected_condition_new
        expectedConditionList = expectedCondition ? expectedCondition?.split(' | ') : []
        expectedConditionListFull = talent?.last_company?.expected_condition_full?.split(' | ') || [];
        setSelectedOptions(expectedCondition ? expectedCondition?.split(' | ') : [])
        setUnselectedOptions(expectedConditionListFull.filter((item: string) => !expectedConditionList.includes(item)))
      }
    }, [talent]);

    const handleAddOtherExpectedCondition = () => {
        setDataOtherExpectedCondition((prevDataOtherReason) => [...prevDataOtherReason, ""]);
    }

    const handleChangeOtherExpectedCondition = (e: any, idx: any) => {
        const newDataOtherExpectedCondition = [...dataOtherExpectedCondition];
        newDataOtherExpectedCondition[idx] = e.target.value;
        setDataOtherExpectedCondition(newDataOtherExpectedCondition);
        setDisplay(true)
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    };

  const handleSave = async (e: any) => {
    setErrorMessage('');
    let expectedCondition = [...selectedOptions, ...dataOtherExpectedCondition.filter(item => item.trim()),].join(' | ').trim();
    let expectedConditionFull = expectedConditionListFull.filter((item: string) =>
      expectedCondition.includes(item) || unselectedOptions.includes(item)
    ).map((item: string) => item.trim()).join(' | ').trim();

    const expectedConditionFullClean = expectedConditionFull;
    const expectedConditionClean = expectedCondition;
    const conditionCheckUniqueArr = [...selectedOptions, ...dataOtherExpectedCondition.filter(item => item.trim()), ...unselectedOptions];
    if (new Set(conditionCheckUniqueArr).size !== conditionCheckUniqueArr.length) {
      setErrorMessage('重複しています。');
      return false;
    }

    if (expectedConditionFull.length > 2000) {
      setErrorMessage('2000文字を超えてます。');
      return false;
    }

    await dispatch(updateBasicInformation({
      formData: {
        ...talent,
        expected_condition: expectedConditionClean,
        expected_condition_full: expectedConditionFullClean,
        change_point: 'expectedCondition',
      }
    }));

    setDisplay(false);
    setDataOtherExpectedCondition([]);
    onClose();
  };

  const handleCheckboxChange = (item: any) => {
        const { value, checked } = item;
        setSelectedOptions((prev) => checked ? [...prev, value] : prev.filter((option) => option !== value));
        setUnselectedOptions((prev) => checked ? prev.filter((option) => option !== value) : [...prev, value]);
        setDisplay(true)
    };

    return (
        <div className="w-[392px] max-w-full h-full bg-white rounded-2xl pt-3 alu-panel-box-shadow">
            <div className="flex items-center justify-between px-4 mb-1">
                <h2 className="text-xl leading-[1.875rem] font-bold alu-text-base-2">
                    希望条件の編集
                </h2>
                <CustomIconButton onClick={onClose}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_8574_265)">
                        <path
                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                            fill="currentColor"
                        />
                        </g>
                        <defs>
                        <clipPath id="clip0_8574_265">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                        </defs>
                    </svg>
                </CustomIconButton>
            </div>
            <div className="overflow-y-auto custom-scrollbar h-[calc(100%-40px)] px-4 pb-4">
                <form onSubmit={handleSubmit}  className="mt-6 w-full flex flex-col">
                    <div className="mb-4 flex flex-wrap gap-4 flex-col">
                        {expectedConditionListFull?.map((item: any, idx: any) => (
                        <div className="flex gap-2 items-center" key={idx}>
                            <CheckboxButton
                                id={"condition" + idx}
                                name="condition[]"
                                label={item}
                                value={selectedOptions.includes(item)}
                                onChange={()=>handleCheckboxChange({value: item, checked: !selectedOptions.includes(item)})}
                            />
                        </div>
                        ))}
                    </div>
                    {dataOtherExpectedCondition?.map((item, idx) => (
                        <div className="flex items-center justify-between gap-[0.625rem] mb-4" key={idx}>
                            <div className="flex-1">
                                <TextInput
                                    id={"other" + idx}
                                    name="otherReason[]"
                                    placeholder="希望条件を入力"
                                    value={item}
                                    onChange={(e:any) => handleChangeOtherExpectedCondition(e, idx)}
                                />
                            </div>
                            <CustomIconButton
                            customStyle="shrink-0"
                            onClick={() => {
                                setDataOtherExpectedCondition(prev => prev.filter((_,index) => index !== idx))
                            }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M200-440v-80h560v80H200Z"/></svg>
                            </CustomIconButton>
                        </div>
                    ))}
                    {errorMessage && <p className='alu-text-error text-sm mb-4'>※{errorMessage}</p>}
                    <div className="mb-10">
                        <button className="flex items-center gap-1 p-1 hover:bg-[#FFF3E5] rounded" onClick={handleAddOtherExpectedCondition}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clipPath="url(#clip0_13284_8548)">
                                    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#FF861A" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_13284_8548">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="alu-text-title text-sm">その他の希望条件を追加</p>
                        </button>
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <CustomButton
                            type="button"
                            onClick={() => onClose()}
                            width="full"
                            variant="outline"
                            size="md"
                        >
                            キャンセル
                        </CustomButton>
                        <CustomButton
                            onClick={handleSave}
                            type="submit" disabled={isLoading || !isDisplay}
                            width="full"
                            size="md"
                        >
                            <p>{isLoading ? "保存中..." : "保存"}</p>
                            {isLoading && (
                                <span><LoadingSpinner /></span>
                            )}
                        </CustomButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DesiredConditions;
